import React from 'react';
import NavSection from './NavSection';
import { croAdminMenuItems } from './menuItems';

const CROAdminNav = ({ isOpen, expandedSections, onToggleSection, onNavClick }) => {
    return (
        <>
            <NavSection
                isOpen={isOpen}
                sectionKey="dashboards"
                sectionLabel="Dashboards"
                sectionSubtext="Overview & analytics"
                menuItems={croAdminMenuItems.dashboard}
                isExpanded={expandedSections.dashboards}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />

            <NavSection
                isOpen={isOpen}
                sectionKey="croManagement"
                sectionLabel="CRO Management"
                sectionSubtext="Manage consent, data & users"
                menuItems={croAdminMenuItems.management}
                isExpanded={expandedSections.croManagement}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />

            <NavSection
                isOpen={isOpen}
                sectionKey="settings"
                sectionLabel="Settings"
                sectionSubtext="System configuration"
                menuItems={croAdminMenuItems.settings}
                isExpanded={expandedSections.settings}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />

            <NavSection
                isOpen={isOpen}
                sectionKey="reports"
                sectionLabel="Reports"
                sectionSubtext="Analytics & insights"
                menuItems={croAdminMenuItems.reports}
                isExpanded={expandedSections.reports}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />
        </>
    );
};

export default CROAdminNav;